<template>
  <v-row >
    <v-col></v-col>
    <app-search-filter-chip
        v-for="(filterName,index) in selectedFilterNames"
        :key="index"
        :filter="getFilterByName(filterName)"
        @updateObject="updateObject"
        @remove-filter="removeFilterByName(filterName)"
    />
    <v-menu
        offset-y
        :close-on-content-click="false"
        v-model="menu"
    >
      <template v-slot:activator="{ on }">
        <v-chip v-on="on" >
          {{ $t("AppSearchAddFilterBtn.add_filter") }}
<!--          ICON PLUS-->
          <v-icon right>mdi-plus</v-icon>
        </v-chip>
      </template>

      <!-- Input para filtrar las opciones -->
      <div class="menu-background">
        <div style="max-height: 300px; overflow-y: auto;">
        <v-text-field
            :label="$t('AppSearchAddFilterBtn.filter')+'...'"
            v-model="search"
            solo
            clearable
        ></v-text-field>

        <!-- Lista de opciones filtrables -->
          <v-list dense>
            <v-list-item-group v-if="filters">
              <v-list-item v-for="(f,index) in filteredFilters" :key="index" @click="addFilter(f)">
                <v-list-item-icon>
                  <v-icon>{{ f.icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>
                    {{ f.label }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
            <v-list-item v-else>
              <v-list-item-content>No se han obtenido resultados</v-list-item-content>
            </v-list-item>
          </v-list>
        </div>
      </div>
    </v-menu>
    <v-col></v-col>
  </v-row>
</template>

<script>

import AppTextField from "@/components/layout/AppTextField";
import AppSearchFilterChip from "@/components/layout/AppSearchFilterChip.vue";

export default {
  name: "AppSearchAddFilterBtn",
  components: {
    AppSearchFilterChip,
    AppTextField,
  },
  props: {
    filters: {
      type: Object,
      required: true,
    },
    conditions: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    initial_filters: {
      type:Array,
      default: () => ([]),
    }
  },
  data() {
    return {
      search: "",
      menu: false,
      conditionFilters: [],
      selectedFilterNames: [], // Ahora guardamos solo los nombres de los filtros
    };
  },
  methods: {
    // Obtiene el filtro actual de filters por nombre
    getFilterByName(name) {
      return this.filters[name] || {};
    },
    updateObject(data){
      this.$emit('updateObject', {
        selected_filters: this.selectedFilterNames.map(name => this.getFilterByName(name)),
        param: data
      });
    },
    addFilter(filter) {
      // Check if the filter is already selected
      if (this.selectedFilterNames.includes(filter.name)) {
        console.warn("Filter already selected:", filter);
        this.search = "";
        this.menu = false;
        return;
      }
      // Add the filter name to the selected filters
      this.selectedFilterNames.push(filter.name);
      this.search = "";
      this.menu = false;
      this.$emit('add-filter', filter)
    },
    removeFilterByName(filterName) {
      this.$emit('remove-filter', filterName)
      this.selectedFilterNames = this.selectedFilterNames.filter(name => name !== filterName);
    },
    removeFilter(filter) {
      this.removeFilterByName(filter.name);
    },
    resetFilters() {
      for (let i = 0; i < this.selectedFilterNames.length; i++) {
        this.$emit('remove-filter', this.selectedFilterNames[i]);
      }
      this.selectedFilterNames = [];
    }
  },
  async mounted() {
    if (this.initial_filters.length > 0) {
      for (let x in this.initial_filters) {
        // Guardar solo el nombre del filtro
        const filter = this.initial_filters[x];
        // Solo añadir si el filtro existe en filters (evita duplicados con filtros "pineados")
        if (filter && filter.name && this.filters[filter.name]) {
          this.selectedFilterNames.push(filter.name);
        }
      }
    }
  },
  computed: {
    filteredFilters() {
      const normalizedSearch = this.search.toLowerCase();
      let result = [];

      Object.entries(this.filters).forEach(([key, filter]) => {
        const passesConditions = !(key in this.conditions) || this.conditions[key];
        const matchesSearch = !this.search || (filter.label && filter.label.toLowerCase().includes(normalizedSearch));

        if (passesConditions && matchesSearch) {
          result.push(filter);
        }
      });

      // Ordenar alfabéticamente por label
      result.sort((a, b) => {
        const labelA = (a.label || '').toLowerCase();
        const labelB = (b.label || '').toLowerCase();
        return labelA.localeCompare(labelB);
      });

      return result;
    },
  },
  // mounted() {
  //   console.log("Mounted - AppSearchAddFilterBtn --->", this.filters);
  // },
};
</script>
<style scoped>
.menu-background {
  background-color: white;
}
</style>